import AppActions from '../actions/AppActions';
import AppStore from '../stores/AppStore';

/**
 * Processes a given SCAN object by either adding, incrementing or removing a COP check attempt from a given object.
 *
 * @param  {Object}  scanDetails        sort code and account number data of attempted check
 * @param  {Boolean} resetThiskey       optional boolean, will remove entry for SCAN if set
 * @param  {Object}  sessionCOPChecks   object containing COP check attempts to be amended
 * @return {Object}                     object containing amended COP check attempts for session
 */

const processSessionCOPCheck = (
  scanDetails,
  resetThisKey = false,
  sessionCOPChecks = {}
) => {
  const { accountNumber, sortCode } = scanDetails;
  const identifier = `${accountNumber}${sortCode.replace(/-/g, '')}`;
  const currentEntry = sessionCOPChecks[identifier] || {};

  let newSessionCOPChecks = sessionCOPChecks;

  if (resetThisKey) {
    delete newSessionCOPChecks[identifier];
  } else {
    const { tryCount = 0 } = currentEntry;
    newSessionCOPChecks[identifier] = {
      tryCount: tryCount + 1,
    };
  }

  return newSessionCOPChecks;
};

/**
 * Handler function which will process and then set new session COP check data in the AppStore.
 *
 * @param  {Object}  scanDetails        sort code and account number data of attempted check
 * @param  {Boolean} resetThisKey       optional boolean, will remove entry for SCAN if set
 * @param  {Object}  sessionCOPChecks   object containing COP check attempts to be amended
 */

const copCheckTriggeredHandler = (scanDetails, resetThisKey = false) => {
  const sessionCOPChecks = AppStore.getSessionCOPChecks();
  AppActions.setSessionCOPChecks(scanDetails, resetThisKey, sessionCOPChecks);
};

export { copCheckTriggeredHandler, processSessionCOPCheck };
